<template>
  <dashboard-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditationtechnical/planningteam/store/${inputs.id}`
            : `/accreditationtechnical/planningteam/store/`
        "
      >
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("OEC") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="text"
            v-model="client"
            :required="true"
            :disabled="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ typeName }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="text"
            v-model="code"
            :required="true"
            :disabled="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Tipo") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="text"
            v-model="type"
            :required="true"
            :disabled="true"
          />
        </div>
        <hr />
        <div class="form-group row align-items-center" v-if="evaluationType == 'E'">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Evaluador lider") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="search-select"
            v-model="inputs.evaluator_id"
            :list="evaluatorsLiderList"
            :required="true"
          />
        </div>

        <!-- Condiciones -->

        <div class="form-group row align-items-center" v-if="evaluationType == 'E'">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Evaluadores") }}
          </label>
          <app-input
            class="col-sm-9"
            type="multi-select"
            :list="evaluatorList"
            :isAnimatedDropdown="true"
            v-model="evaluator"
          />
        </div>

        <div class="form-group row align-items-center" v-if="evaluationType == 'T'">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Evaluadores") }}
          </label>
          <app-input
            class="col-sm-9"
            type="multi-select"
            :list="evaluatorList"
            :isAnimatedDropdown="true"
            v-model="evaluator"
            required
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Evaluadores en entrenamiento") }}
          </label>
          <app-input
            class="col-sm-9"
            type="multi-select"
            :list="evaluatorsTrainingList"
            :isAnimatedDropdown="true"
            v-model="evaluatorsTraining"
          />
        </div>

        <div
          class="form-group row align-items-center"
          v-if="evaluationType == 'E'"
        >
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Evaluadores lider en entrenamiento") }}
          </label>
          <app-input
            class="col-sm-9"
            type="multi-select"
            :list="liderEvaluatorTrainingList"
            :isAnimatedDropdown="true"
            v-model="liderEvaluatorTraining"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Expertos técnicos") }}
          </label>
          <app-input
            class="col-sm-9"
            type="multi-select"
            :list="technicalExpertList"
            :isAnimatedDropdown="true"
            v-model="technicalExpert"
          />
        </div>

        <div
          class="form-group row align-items-center"
        >
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Observadores") }}
          </label>
          <app-input
            class="col-sm-9"
            type="multi-select"
            :list="observerList"
            :isAnimatedDropdown="true"
            v-model="observer"
          />
          <br>
          <div class="row w-100 justify-content-end">
            <a
                :href="`/observer/maintenance`"
                target="_blank"
                class="d-flex justify"
            >Añadir observador</a
            >
          </div>
        </div>


        <!-- <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Seleccionar un color") }}
          </label>
          <v-swatches v-model="color"></v-swatches>
        </div> -->

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Fecha y hora inicio") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-5"
            type="date"
            v-model="inputs.date_start"
            :required="true"
            :placeholder="$t('Agregar fecha')"
          />
          <app-input
            class="col-sm-4"
            type="time"
            :required="true"
            v-model="inputs.time_start"
            :placeholder="$t('Agregar hora')"
          />
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Fecha y hora final") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-5"
            type="date"
            v-model="inputs.date_end"
            :required="true"
            :placeholder="$t('Agregar fecha')"
          />
          <app-input
            class="col-sm-4"
            type="time"
            :required="true"
            v-model="inputs.time_end"
            :placeholder="$t('Agregar hora')"
          />
        </div>
      </form>
    </template>
  </dashboard-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import VSwatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";

export default {
  name: "ModalTest",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    evaluatorsLiderList: Array,
    liderEvaluatorTrainingList: Array,
    evaluatorList: Array,
    evaluatorsTrainingList: Array,
    technicalExpertList: Array,
    observerList: Array,
    evaluation: Object,
    dateSelect: Date,
  },
  components: {
    VSwatches,
  },
  data() {
    return {
      preloader: false,
      color: "#1CA085",
      dateEnd: this.dateSelect,
      inputs: {
        date_start: this.dateSelect,
        date_end: this.dateSelect,
      },
      liderEvaluatorTraining: [],
      evaluator: [],
      evaluatorsTraining: [],
      observer: [],
      technicalExpert: [],
      client: "",
      code: "",
      type: "",
      evaluationType: "",
      typeName: "",
      modalId: "asign-add-edit-modal",
      modalTitle: "",
    };
  },

  created() {
    this.evaluationInfo();
    this.modalTitle = this.$t("Planificar fecha para esta " + this.typeName);
    // this.preloader = true;
  },
  methods: {
    submit() {
      const tmp = { ...this.inputs };
      if (tmp.date_start) {
        const d = tmp.date_start;
        tmp.date_start = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");
      }

      if (tmp.date_end) {
        const d = tmp.date_end;
        tmp.date_end = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join("-");
      }

      var request = {};
      request["id"] = this.evaluation.id;
      request["date_start"] = tmp.date_start;
      request["date_end"] = tmp.date_end;
      request["color"] = '#1CA085'
      request["evaluator_id"] = this.inputs.evaluator_id;
      request[
        "accreditation_id"
      ] = this.evaluation.accreditation_applications.id;
      request["time_start"] = this.inputs.time_start;
      request["time_end"] = this.inputs.time_end;

      request["liderEvaluatorTraining"] = this.liderEvaluatorTraining;
      request["evaluator"] = this.evaluator;
      request["observer"] = this.observer;
      request["technicalExpert"] = this.technicalExpert;
      request["evaluatorsTraining"] = this.evaluatorsTraining;
      
      this.save(request);
    },

    evaluationInfo() {
      this.client = this.evaluation.accreditation_applications.organization.business_name;
      this.code = this.evaluation.code;
      this.type = this.evaluation.accreditation_applications.accreditation_type.name;
      this.evaluationType = this.evaluation.type;
      if (this.evaluationType == "T") {
        this.typeName = "Testificación";
      } else {
        this.typeName = "Evaluación";
      }
    },
    afterSuccess(response) {
      if (response.data.status == true) {
        this.$toastr.s(response.data.message);
        this.$hub.$emit("reload-" + this.tableId);
      } else {
        this.$toastr.e(response.data.message);
      }
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
  },
};
</script>